namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_form_custom, {
		
		Form: {
			Body: {
				padding: {
					left: $mol_gap.block,
					right: $mol_gap.block,
				},
			},
		},

		Actions: {
			width: '100%',
			padding: 0,
			justify: {
				content: 'space-between',
			},
		},
		Clear_actions: { flex: { wrap: 'wrap' }, gap: $mol_gap.text },
		
	} )
	
}
